import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./ARIAccidentConfirmed.scss";
import { Header, TitleBar } from "webapp/components";
import CallIcon from "@mui/icons-material/Call";
import holmanLogo from "assets/logo/holmanLogo.png";
const config_phone_number = process.env.REACT_APP_ARI_PHONE1;

export default function ARIAccidentConfirmed(props) {
  const { t } = useTranslation();

  const [phoneNumber] = useState("+1 855-383-1115"); //(config_phone_number || "916-947-5411");

  const ConfirmServiceObj = {
    img: holmanLogo,
    fragment: (
      <React.Fragment>
        <p>{t("description.TVLAccidentConfirmedTitleBar1")}</p>
      </React.Fragment>
    ),
  };

  return (
    <>
      <div className="view-accident-confirmed">
        <Header
          currState={props.currState}
          information={t("description.TVLAccidentConfirmedHeader")}
          disableBack={true}
        />
        <TitleBar data={ConfirmServiceObj} />
        <p className="message">
          <span>{t("ARI.AccidentConfirm.ARIAccidentConfirmedMessage1")}</span>
          &nbsp;
          <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
          &nbsp;
          <span>{t("ARI.AccidentConfirm.ARIAccidentConfirmedMessage2")}</span>
        </p>
        <a href={`tel:${phoneNumber}`} className="clickToDial">
          <CallIcon />
          <span>{phoneNumber}</span>
        </a>
      </div>
    </>
  );
}
